import React from 'react';

const RECENT_ACTIVITY = [
  { user: 'Ryan Miskulin', action: 'logged in', time: '2 minutes ago', icon: '\uD83D\uDFE2' },
  { user: 'Jordan Lutz', action: 'created invoice #1047', time: '15 minutes ago', icon: '\uD83D\uDCB0' },
  { user: 'Lucas Mason', action: 'added a new customer', time: '1 hour ago', icon: '\uD83D\uDC65' },
  { user: 'Lee Mehling', action: 'generated compliance report', time: '3 hours ago', icon: '\uD83D\uDCC4' },
  { user: 'Derek Littles', action: 'logged in', time: '5 hours ago', icon: '\uD83D\uDFE2' },
];

export default function OverwatchPage() {
  const statCards = [
    { label: 'Platform Health', value: '99.9%', sub: 'Uptime', color: '#10b981', icon: '\uD83D\uDFE2' },
    { label: 'Active Users', value: '18', sub: 'Team Members', color: '#6366f1', icon: '\uD83D\uDC65' },
    { label: 'Monthly Revenue', value: '$48,250', sub: '+12% this month', color: '#f59e0b', icon: '\uD83D\uDCB0' },
    { label: 'Open Tasks', value: '7', sub: 'Across all modules', color: '#ef4444', icon: '\uD83D\uDCCB' },
  ];

  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div className="page-header" style={{ marginBottom: 28 }}>
        <h1 className="page-title" style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>
          Overwatch
        </h1>
        <p className="page-subtitle" style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>
          The Forge Standard &mdash; Admin Command Center
        </p>
      </div>

      {/* Stat Cards */}
      <div className="stats-grid" style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220, 1fr))',
        gap: 16, marginBottom: 28
      }}>
        {statCards.map((card, i) => (
          <div key={i} className="stat-card" style={{
            padding: 20, background: 'var(--card)', borderRadius: 12,
            border: '1px solid var(--border)'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
              <span style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                {card.label}
              </span>
              <span style={{ fontSize: 20 }}>{card.icon}</span>
            </div>
            <div className="stat-value" style={{ fontSize: 28, fontWeight: 700, color: card.color, marginBottom: 4 }}>
              {card.value}
            </div>
            <div className="stat-label" style={{ fontSize: 12, color: 'var(--text-muted)' }}>
              {card.sub}
            </div>
          </div>
        ))}
      </div>

      {/* System Status + Recent Activity */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {/* System Status */}
        <div className="card" style={{
          padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)'
        }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: '0 0 16px' }}>
            System Status
          </h2>
          {[
            { name: 'Authentication', status: 'Operational', color: '#10b981' },
            { name: 'Database', status: 'Operational', color: '#10b981' },
            { name: 'API Services', status: 'Operational', color: '#10b981' },
            { name: 'File Storage', status: 'Operational', color: '#10b981' },
          ].map((sys, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '10px 0', borderBottom: i < 3 ? '1px solid var(--border)' : 'none'
            }}>
              <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>{sys.name}</span>
              <span style={{
                padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 600,
                background: `${sys.color}20`, color: sys.color
              }}>
                {sys.status}
              </span>
            </div>
          ))}
        </div>

        {/* Recent Activity */}
        <div className="card" style={{
          padding: 24, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)'
        }}>
          <h2 className="card-title" style={{ color: 'var(--text)', fontSize: 16, fontWeight: 600, margin: '0 0 16px' }}>
            Recent Activity
          </h2>
          {RECENT_ACTIVITY.map((item, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 0',
              borderBottom: i < RECENT_ACTIVITY.length - 1 ? '1px solid var(--border)' : 'none'
            }}>
              <span style={{ fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ color: 'var(--text)', fontSize: 13 }}>
                  <strong>{item.user}</strong> {item.action}
                </div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11, marginTop: 2 }}>{item.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
